import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';

const MUTATION = gql`
  mutation ExtractPerformanceCenterBenchmarks(
    $projectId: ID!
    $text: String!
    $assetType: AssetTypeEnum!
    $adAccountId: ID!
    $userGoal: String!
    $variationId: ID
    $comparisonSetName: String
  ) {
    extractPerformanceCenterBenchmarks(
      projectId: $projectId
      text: $text
      assetType: $assetType
      adAccountId: $adAccountId
      userGoal: $userGoal
      variationId: $variationId
      comparisonSetName: $comparisonSetName
    ) {
      position
      comparisonSet {
        name
        description
        userGoal
        examples
      }
    }
  }
`;

const prepareContext = (params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"ExtractPerformanceCenterBenchmarks" request [${JSON.stringify(params)}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const extractPerformanceCenterBenchmarks = (
  { projectId, text, assetType, adAccountId, userGoal, variationId, comparisonSetName },
  options
) => {
  const variables = {
    projectId,
    text,
    assetType,
    adAccountId,
    userGoal,
    variationId,
    comparisonSetName,
  };
  const mutateOptions = {
    mutation: MUTATION,
    variables,
    context: prepareContext(variables),
  };

  if (options && options.abortSignal) {
    mutateOptions.context = {
      ...mutateOptions.context,
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }
  return apolloClient.mutate(mutateOptions).then(({ data }) => getSingleProp(data));
};
